import { CanActivateFn } from "@angular/router";
import { inject } from "@angular/core";
import { AuthTokenService } from "@app/services/auth-token.service";

export const ssoIdentityGuard: CanActivateFn = () =>
    inject(AuthTokenService).hasSsoIdentity();
